<template>
  <b-form-group
    v-if="isPremium && hasRepeatType"
    :label="$t('tasks.form.repeatInterval')"
    label-for="repeat_interval"
  >
    <b-form-input
      id="repeat_interval"
      v-model.number="dataItem.repeat_interval"
      type="number"
      min="1"
      :placeholder="intervalPlaceholder"
    />
    <small class="text-muted">{{ intervalHelpText }}</small>
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormInput } from 'bootstrap-vue'
import { packageLimit } from '@/libs/packageLimits'

export default {
  name: 'TasksRepeatIntervalCard',
  components: { BFormGroup, BFormInput },
  computed: {
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
    isPremium() {
      return packageLimit('PROJECTS', 1)
    },
    hasRepeatType() {
      return !!this.dataItem.repeat_type
    },
    intervalPlaceholder() {
      return this.$t('tasks.form.intervalPlaceholder')
    },
    intervalHelpText() {
      const t = this.dataItem.repeat_type
      return t ? this.$t(`tasks.form.intervalHelp.${t}`) : ''
    },
  },
}
</script>
